/** Path from `shared/assets/icons/vector.svg` — original → current size arrow. */
export const SIZE_ARROW_PATH_D =
  'M1 6.36328C0.447715 6.36328 -4.82823e-08 6.811 0 7.36328C4.82823e-08 7.91557 0.447715 8.36328 1 8.36328L1 7.36328L1 6.36328ZM21.17 8.07039C21.5605 7.67986 21.5605 7.0467 21.17 6.65617L14.806 0.292212C14.4155 -0.0983121 13.7823 -0.0983121 13.3918 0.292212C13.0013 0.682737 13.0013 1.3159 13.3918 1.70643L19.0487 7.36328L13.3918 13.0201C13.0013 13.4107 13.0013 14.0438 13.3918 14.4343C13.7823 14.8249 14.4155 14.8249 14.806 14.4343L21.17 8.07039ZM1 7.36328L1 8.36328L20.4629 8.36328L20.4629 7.36328L20.4629 6.36328L1 6.36328L1 7.36328Z';

export const SIZE_ARROW_VIEWBOX = '0 0 22 15';
/** Tooltip display size (viewBox is 22×15). */
export const SIZE_ARROW_WIDTH = 14;
export const SIZE_ARROW_HEIGHT = 10;
/** Bubble label size — sized to sit with 11px size text. */
export const BUBBLE_SIZE_ARROW_WIDTH = 11;
export const BUBBLE_SIZE_ARROW_HEIGHT = 7;
export const SIZE_ARROW_GAP = 3;

/** HTML snippet for volume tooltips (same glyph as vector.svg). */
export function sizeArrowSvgHtml(className = 'vt-size-arrow-svg'): string {
  return (
    `<svg class="${className}" width="${SIZE_ARROW_WIDTH}" height="${SIZE_ARROW_HEIGHT}" viewBox="${SIZE_ARROW_VIEWBOX}" fill="none" aria-hidden="true">` +
    `<path d="${SIZE_ARROW_PATH_D}" fill="currentColor"/>` +
    `</svg>`
  );
}

const svgNs = 'http://www.w3.org/2000/svg';

/** Append an inline size arrow for D3 bubble labels; returns the root `<svg>`. */
export function appendSizeArrowSvg(
  parent: Element,
  opts: { x: number; y: number; width?: number; height?: number; fill?: string }
): SVGSVGElement {
  const w = opts.width ?? BUBBLE_SIZE_ARROW_WIDTH;
  const h = opts.height ?? BUBBLE_SIZE_ARROW_HEIGHT;
  const svg = document.createElementNS(svgNs, 'svg');
  svg.setAttribute('x', String(opts.x));
  svg.setAttribute('y', String(opts.y));
  svg.setAttribute('width', String(w));
  svg.setAttribute('height', String(h));
  svg.setAttribute('viewBox', SIZE_ARROW_VIEWBOX);
  svg.setAttribute('fill', 'none');
  svg.setAttribute('aria-hidden', 'true');
  const path = document.createElementNS(svgNs, 'path');
  path.setAttribute('d', SIZE_ARROW_PATH_D);
  path.setAttribute('fill', opts.fill ?? 'currentColor');
  svg.appendChild(path);
  parent.appendChild(svg);
  return svg;
}

/** Estimated width of `original [arrow] current` for chord fit checks. */
export function managedSizeArrowRowWidth(
  original: string,
  current: string,
  charW: number,
  arrowW = BUBBLE_SIZE_ARROW_WIDTH,
  gap = SIZE_ARROW_GAP
): number {
  return original.length * charW + gap + arrowW + gap + current.length * charW;
}
